import { fetchTrackingRecordSave } from "@/api/track";
import { GetTrackingRecordSaveParams } from "@/api/track/interface";
import { useCallback } from "react";

type UseTrackProps = GetTrackingRecordSaveParams;

export function useTrack() {
  const tracking = useCallback((_props: UseTrackProps) => {
    fetchTrackingRecordSave(_props);
  }, []);

  return { tracking };
}
